import { Button, EmptyState } from '@dev-spendesk/grapes';
import { type ReactElement } from 'react';

import { useTranslation } from 'common/hooks/useTranslation';

import './UnexpectedError.css';

type Props = {
  actions?: ReactElement;
};

export const UnexpectedError = ({ actions }: Props) => {
  const { t } = useTranslation('errors');

  return (
    <EmptyState
      className="UnexpectedError"
      iconName="hexagone-cross"
      iconVariant="alert"
      title={t('unexpectedError.techTitle')}
      actions={
        <div className="flex flex-col gap-24">
          <Button
            id="intercom-message"
            variant="primaryAlert"
            text={t('unexpectedError.contactSupport')}
            onClick={() => window.Intercom('show')}
          />
          {actions}
        </div>
      }
      subtitle={t('unexpectedError.subtitle')}
    />
  );
};
